import { MutableRef } from "preact/hooks"

export const useLanguageSelector = (languagesRef: MutableRef<HTMLButtonElement[]>, focusedLanguage: MutableRef<number>) => {
    const firstLanguageElement = languagesRef.current[0];

    const focusFirstLanguageElement = () => {
        firstLanguageElement?.focus();

        return firstLanguageElement;
    };

    const focusNextLanguage = () => {
        if (focusedLanguage.current == null) {
            return focusFirstLanguageElement();
        }

        if (focusedLanguage.current === languagesRef.current.length - 1) {
            return;
        }

        const nextIndex = (focusedLanguage.current + 1) % languagesRef.current.length;
        const languageElement = languagesRef.current[nextIndex];
        languageElement.focus();

        return languageElement;
    }

    const focusPreviousLanguage = () => {
        if (focusedLanguage.current == null) {
            return focusFirstLanguageElement();
        }

        if (focusedLanguage.current === 0) {
            return;
        }

        const nextIndex = (focusedLanguage.current - 1) % languagesRef.current.length;
        const languageElement = languagesRef.current[nextIndex];
        languageElement.focus();

        return languageElement;
    }

    return {
        focusFirstLanguageElement,
        focusNextLanguage,
        focusPreviousLanguage,
    }
}
